import { render, staticRenderFns } from "./TrackingCategoriesFlow.vue?vue&type=template&id=cb037200&scoped=true"
import script from "./TrackingCategoriesFlow.vue?vue&type=script&lang=js"
export * from "./TrackingCategoriesFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb037200",
  null
  
)

export default component.exports